module.exports = __webpack_public_path__ + "australia.svg?cab2eac60acd879c5b5d0b3c70ec913b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/australia.svg
// module id = 97
// module chunks = 10